import script from "./TableMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TableMenu.vue?vue&type=script&setup=true&lang=js"

import "./TableMenu.vue?vue&type=style&index=0&id=558ce47b&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558ce47b"]])

export default __exports__